import { Component, OnInit, Input, inject } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { HasPermissionDirective } from '../../directives/permissions.directive';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-reason-text',
  templateUrl: './reason-text.component.html',
  styleUrls: ['./reason-text.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatIconModule,
    HasPermissionDirective,
  ],
})
export class ReasonTextComponent implements OnInit {
  private envSvc = inject(EnvironmentService);
  private ss = inject(SessionStorageService);
  private location = inject(Location);

  @Input() data;
  @Input() selected;
  @Input() defaultView;
  @Input() expanded = true;
  @Input() hideExplanations = false;
  @Input() forceNeutral = false;
  @Input() accountLinkingStatus = '';
  @Input() linkString = '';
  @Input() tags: {
    positive: string;
    neutral: string;
    negative: string;
    criteria: 'score' | 'reasonType' | null;
  } = { positive: '', neutral: '', negative: '', criteria: null };

  private environment;
  viewMode = 'grid';
  path: string;
  org: string;
  yellowNegative = false;
  rights = [];

  ngOnInit() {
    this.rights = this.ss.get('rights');
    this.environment = this.envSvc.get();
    this.org = this.environment.org || 'basev2';
    this.path = this.environment.assets ? this.environment.assets : '';

    if (this.defaultView) {
      this.viewMode = this.defaultView;
    }

    const globals = this.ss.get('globals');

    if (globals && globals.GlobalsGroup.UnitReasonTextSettings) {
      this.yellowNegative =
        globals.GlobalsGroup.UnitReasonTextSettings.TurnNegativeReasonTextYellow;
    }

    if (this.yellowNegative) {
      this.path = 'mass/';
    }
  }

  isOdd(num) {
    return num % 2;
  }

  showAccountLinking(reason) {
    return (
      this.rights.includes('AccountLinking') &&
      ['TM_MI_PrelimAccountProfile', 'TM_MI_NoAccountProfile'].includes(
        reason.name
      ) &&
      !['', 'I'].includes(this.accountLinkingStatus)
    );
  }
  linkingNav() {
    if (this.linkString) {
      window.open(
        `${this.location.prepareExternalUrl(this.linkString)}`,
        '_blank'
      );
    }
  }
}
